module.exports = __webpack_public_path__ + "static/26-40bd7d2f9b049f124d71e86ecdae6c10.mp4";